export default {
  "domain": process.env.REACT_APP_AUTH0_DOMAIN, //eslint-disable-line
  "clientId": process.env.REACT_APP_AUTH0_CLIENTID, //eslint-disable-line
  "audience": process.env.REACT_APP_AUTH0_AUDIENCE //eslint-disable-line
}